import * as React from "react";
import { RichTextInput } from "ra-input-rich-text";
import {
  SimpleForm,
  TextInput,
  DateInput,
  SelectInput,
  AutocompleteArrayInput,
  Create,
  CreateProps,
  NumberInput,
  BooleanInput,
} from "react-admin";

import { useGetList } from "react-admin";
import { Box } from "@mui/material";
import { DEPARTMENTS, validateOptionalUrl, validateDateRange } from "../../../constants";
import { WarningBox } from "./WarningBox";

export const CreateJobOffer: React.FC<CreateProps> = (props) => {
  const { data: categories = [], isLoading: isLoadingCategories } = useGetList("categories", {
    pagination: { page: 1, perPage: 100 },
  });
  const { data: statuses = [], isLoading: isLoadingStatuses } = useGetList("statuses");

  const [useAutoReference, setUseAutoReference] = React.useState(true);

  const handleToggleAutoReference = React.useCallback(() => {
    setUseAutoReference((prev) => !prev);
  }, []);

  return (
    <div>
      <WarningBox>
        <strong>Atención:</strong> Las ofertas creadas con el estado{" "}
        <em>
          <strong>"Recepción de postulaciones"</strong>
        </em>{" "}
        enviarán un correo electrónico a los postulantes que estén interesados
        en las categorías seleccionadas.
      </WarningBox>
      <Create {...props}>
        <SimpleForm>
          <TextInput source="title" fullWidth required />
          <BooleanInput source="isFeatured" label="Oferta destacada" />
          <Box sx={{ display: "flex", gap: "16px" }}>
            <BooleanInput
              source="useAutoReference"
              label="Asignar Referencia Automática"
              defaultValue={true}
              onChange={handleToggleAutoReference}
            />
            {!useAutoReference && (
              <NumberInput
                source="reference"
                label="Nº de referencia"
                required
              />
            )}
            <TextInput source="address1" label="Dirección" required />
            <DateInput
              source="startDate"
              label="Fecha de inicio"
              required
              validate={(value, allValues) =>
                validateDateRange(value, allValues?.endDate)
              }
            />
            <DateInput
              source="endDate"
              label="Fecha de fin"
              required
              validate={(value, allValues) =>
                validateDateRange(allValues?.startDate, value)
              }
            />
          </Box>
          <Box sx={{ display: "flex", gap: "16px" }}>
            <SelectInput source="department" choices={DEPARTMENTS} required />
            <TextInput
              source="workingHours"
              label="Horario laboral"
              fullWidth
              required
            ></TextInput>
            <TextInput
              source="salary"
              label="Salario"
              fullWidth
              defaultValue={"A convenir"}
            ></TextInput>
            <SelectInput
              source="statusId"
              choices={isLoadingStatuses ? [] : statuses}
              label="Estado"
              required
              disabled={isLoadingStatuses}
            ></SelectInput>
          </Box>
          <TextInput
            source="companyLogoUrl"
            label="Logo de la empresa"
            fullWidth
            validate={(v) => (v ? validateOptionalUrl(v) : undefined)}
          ></TextInput>
          <AutocompleteArrayInput
            source="categories"
            choices={isLoadingCategories ? [] : categories}
            fullWidth
            label="Categorias"
            disabled={isLoadingCategories}
          ></AutocompleteArrayInput>
          <RichTextInput
            source="description"
            label="Descripcion"
            fullWidth
            validate={(v) =>
              v ? undefined : "La oferta debe tener una descripción"
            }
          />
        </SimpleForm>
      </Create>
    </div>
  );
};
